import { render, staticRenderFns } from "./AllPayments.vue?vue&type=template&id=1f84761c&"
import script from "./AllPayments.vue?vue&type=script&lang=js&"
export * from "./AllPayments.vue?vue&type=script&lang=js&"
import style0 from "./AllPayments.vue?vue&type=style&index=0&id=1f84761c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports